import React  from 'react'

import {FieldPickerProps} from "../../../render/picker";
import FieldIcon_Popover from "../components/popover/popover";
import FieldIcon_View from "./view";

type State = {
    currentValue    : string
    showPopover     : boolean
}

export default class FieldIcon_Picker extends React.Component<FieldPickerProps, State> {

    constructor(props: FieldPickerProps) {
        super(props);

        this.state = {
            currentValue    : this.props.field.getViewValue(props.model),
            showPopover     : false
        }
    }

    onChange = (icon: string)=> {
        this.props.model.icon = icon
        this.props.model.save()
        this.forceUpdate()
    }

    onClick = ()=> {
        this.setState({showPopover: true})
    }

    showPopover = (e?:React.SyntheticEvent) => {
        e?.stopPropagation()

        if (!this.props.disabled) {
            this.setState({showPopover: true})
        }
    }

    hidePopover = () => {
        this.setState({showPopover: false})
    }

    render() {

        const classes= Classes({
            'show-popover'  : this.state.showPopover,
            'is-disabled'   : this.props.disabled
        });

        return (
            <div className={Classes("flex-row-center-center", this.props.className)} onClick={this.onClick}>
                <FieldIcon_View className   = {classes}
                                field       = {this.props.field}
                                model       = {this.props.model}
                                params      = {this.props.options}
                                onClick     = {this.showPopover}>
                    {this.state.showPopover && <FieldIcon_Popover parent        = {this}
                                                                  value         = {this.props.model.icon}
                                                                  field         = {this.props.field}
                                                                  hidePopover   = {this.hidePopover}
                                                                  onChange      = {this.onChange}/>
                    }
                </FieldIcon_View>
            </div>
        )
    }
}
